import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";

const SnackbarContext = createContext(null);

// global reference (to be set by provider)
let externalShowMessage;

export const SnackbarProvider = ({ children }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const showMessage = useCallback((message, severity = "info") => {
        setSnackbar({ open: true, message, severity });
    }, []);

    // store globally
    externalShowMessage = showMessage;

    const handleClose = (_, reason) => {
        if (reason === "clickaway") return;
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    return (
        <SnackbarContext.Provider value={{ showMessage }}>
            {children}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleClose} severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    );
};

export const useSnackbar = () => useContext(SnackbarContext);

// 🚀 Global helper (safe for non-components)
export function showSnackbar(message, severity = "info") {
    if (externalShowMessage) {
        externalShowMessage(message, severity);
    } else {
        console.warn("SnackbarProvider is not mounted yet");
    }
}
